import React, { useEffect, useState } from "react";
import {
  Table,
  Divider,
  PageHeader,
  Button,
  Form,
  Select,
  Input,
  message,
  Modal,
  Segmented,
  Radio,
  Checkbox,
  DatePicker,
  Image,
} from "antd";
import {
  FlexRowContainer,
  FlexRowEndContainer,
  FlexRowQuarterContainer,
  FlexRowReverseContainer,
} from "../Common/Container.styles";

import { useNavigate } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";

import * as testAPI from "../../api/test";

import {
  dateToCompactString,
  dateToString, getCode,
  numberWithCommas,
} from "../../util/common";

import Pagination from "react-js-pagination";
import { Option } from "antd/lib/mentions";
import { useRecoilState } from "recoil";
import { searchItemState } from "../../states/atoms";
import TextArea from "antd/lib/input/TextArea";
import {getCertificates} from "../../api/user";

export default function CertificateList() {
  const [searchItem, setSearchItem] = useRecoilState(searchItemState);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const [current, setCurrent] = useState(
    Number(sessionStorage.getItem("page")) ?? 1
  );
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState("전체");

  const [startCreatedDate, setStartCreatedDate] = useState(null);
  const [endCreatedDate, setEndCreatedDate] = useState(null);

  const [showRefundModal, setShowRefundModal] = useState(false);

  const onChange = (page) => {
    setCurrent(page);
    sessionStorage.setItem("page", page);
  };

  const [form] = Form.useForm();

  const searchQuery = Form.useWatch("searchQuery", form);
  const searchKeyword = Form.useWatch("searchKeyword", form);
  const status = Form.useWatch("status", form);
  const bannering = Form.useWatch("bannering", form);
  const size = Form.useWatch("size", form);

  const fetchItems = () => {
    const request = {
      page: current,
      size: size ?? 50,
      startCreatedDate,
      endCreatedDate,
    };
    request[`${searchQuery}`] = searchKeyword;
    request[`${searchItem.searchQuery}`] = searchItem.searchKeyword;

    testAPI.getApplyTests(request).then((res) => {
      if (res.data.linusCode === 1) {
        setTotal(res.data.page.count);
        setItems(res.data.data?.map(item => {
          return {
            ...item,
            key: item.id
          }
        }))
        setLoading(false);
      } else {
        alert(res.data.data.msg);
      }
    });
  };

  useEffect(() => {
    if (current !== 1) {
      setCurrent(1);
      return;
    }

    setLoading(true);
    fetchItems();
  }, [filter, startCreatedDate, endCreatedDate, status, bannering, size, searchItem]);

  useEffect(() => {
    setLoading(true);
    fetchItems();
  }, [current]);

  const onSearch = (e) => {
    if (!searchQuery) {
      message.error("검색조건을 선택해주세요.");
      return;
    }

    if (!searchKeyword) {
      message.error("검색 키워드를 입력해주세요.");
      return;
    }

    const newSearchItem = {
      ...searchItem,
      searchQuery: searchQuery,
      searchKeyword: searchKeyword,
    };
    setSearchItem(newSearchItem);

    setCurrent(1);
    sessionStorage.setItem("page", 1);

    setLoading(true);
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedItems(selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled Banner",
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  // 주문번호, 닉네임, 가입채널, 가입년월일시, 최종로그인년월일시, 마케팅동의여부
  const columns = [
    { title: "ID", dataIndex: "id" },
    { title: "코드", dataIndex: "code",
      render: (val) => {
        return getCode(val) ?? '-'
      },
    },
    {
      title: "보낸 유저 이름/이메일",
      dataIndex: "user",
      render: (val) => {
        return (
          <div onClick={() => navigate(`/user/user/edit/${val?.id}`)}>{val?.name + '\n' + val?.email}</div>
        )
      },
    },
    {
      title: "이름",
      width: '7%',
      dataIndex: "name",
    },
    {
      title: "생년월일",
      dataIndex: "birth",
      render: (val) => {
        return val ?? '-'
      },
    },
    {
      title: "개인고유번호",
      dataIndex: "applyNumber",
      render: (val) => {
        return val ?? '-'
      },
    },
    {
      title: "소속기관",
      dataIndex: "organization",
      render: (val) => {
        return val ?? '-'
      },
    },
    {
      title: "받는 유저 이메일/휴대폰 번호",
      render: (val) => {
        return val?.email + '\n' + val?.phone
      },
    },
    {
      title: "규준집단",
      dataIndex: "group",
      render: (val) => {
        return val ?? '-'
      },
    },
    {
      title: "생성일",
      dataIndex: "createdDate",
      width: "10%",
      render: (val) => {
        return dateToString(val);
      },
    },
  ];

  const searchQueries = [
    {
      title: "코드번호",
      dataIndex: "code",
    },
    {
      title: "보낸 유저 이름",
      dataIndex: "userName",
    },
    {
      title: "보낸 유저 이메일",
      dataIndex: "userEmail",
    },
    {
      title: "받는 유저 이름",
      dataIndex: "name",
    },
    {
      title: "받는 유저 이메일",
      dataIndex: "email",
    },
    {
      title: "받는 유저 휴대폰 번호",
      dataIndex: "phone",
    },
    {
      title: "생년월일",
      dataIndex: "birth",
    },
    {
      title: "개인고유번호",
      dataIndex: "applyNumber",
    },
    {
      title: "소속기관",
      dataIndex: "organization",
    },
    {
      title: "규준집단",
      dataIndex: "group",
    },
  ];

  return (
    <div>
      <PageHeader
        className="site-page-header"
        title="인증코드 목록"
        subTitle={`총 ${total}개의 인증코드가 존재합니다.`}
      />
      <Form form={form} onFinish={onSearch}>
        <FlexRowContainer style={{ marginTop: "10px" }}>
          <FlexRowContainer>
            <Form.Item name="searchQuery" initialValue={searchItem.searchQuery}>
              <Select placeholder="검색조건" style={{width: 150}}>
                {searchQueries?.map((c) => {
                  return (
                    <Select.Option key={c.dataIndex} value={c.dataIndex}>
                      {c.title}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              name="searchKeyword"
              initialValue={searchItem.searchKeyword}
            >
              <Input placeholder="검색 키워드를 입력하세요" />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                htmlType="submit"
              />
            </Form.Item>
          </FlexRowContainer>
        </FlexRowContainer>
        <FlexRowContainer style={{ marginTop: "30px" }}>
          <Button
            type="primary"
            onClick={(e) => {
              e.preventDefault();
              const newSearchItem = {
                ...searchItem,
                searchQuery: null,
                searchKeyword: null,
              };
              setSearchItem(newSearchItem);

              setCurrent(1);
              sessionStorage.setItem("page", 1);
              form.setFieldValue("searchQuery", null);
              form.setFieldValue("searchKeyword", null);
            }}
          >
            검색 조건 초기화
          </Button>
        </FlexRowContainer>
      </Form>
      <Divider />
      <Table
        pagination={false}
        loading={loading}
        columns={columns}
        dataSource={items}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        // onRow={(record, rowIndex) => {
        //   return {
        //     onClick: (event) => {
        //       navigate(`/setting/banner/edit/${record.id}/`);
        //     }, // click row
        //     onDoubleClick: (event) => {}, // double click row
        //     onContextMenu: (event) => {}, // right button click row
        //     onMouseEnter: (event) => {}, // mouse enter row
        //     onMouseLeave: (event) => {}, // mouse leave row
        //   };
        // }}
      />
      <FlexRowEndContainer style={{ marginTop: "30px" }}>
        <Pagination
          activePage={current}
          itemsCountPerPage={size ?? 50}
          totalItemsCount={total}
          pageRangeDisplayed={10}
          onChange={onChange}
        />
      </FlexRowEndContainer>
    </div>
  );
}
